var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemBlockFilledLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  viewBox: "0 0 18 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2 0a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A1A",
  fillRule: "evenodd",
  d: "M5 5a1 1 0 0 1 1-1h3.522a2 2 0 0 1 .135.006 3.456 3.456 0 0 1 1.29.35c.369.184.768.476 1.073.933.308.463.48 1.036.48 1.711 0 .734-.164 1.32-.432 1.772.162.143.316.314.452.517.308.463.48 1.036.48 1.711s-.172 1.248-.48 1.71c-.305.458-.704.75-1.073.934a3.45 3.45 0 0 1-1.425.356H6a1 1 0 0 1-1-1zm4.975 3 .042-.007a.5.5 0 0 0 .178-.075c.063-.042.305-.21.305-.918 0-.325-.078-.502-.145-.602a.76.76 0 0 0-.302-.254A1.5 1.5 0 0 0 9.49 6H7v2zM7 10v2h2.991l.024-.001q.043-.003.133-.017c.122-.02.27-.059.405-.126a.76.76 0 0 0 .302-.255c.067-.099.145-.276.145-.601s-.078-.502-.145-.602a.76.76 0 0 0-.302-.254 1.5 1.5 0 0 0-.538-.143L9.99 10z",
  clipRule: "evenodd"
})));
export default SvgGemBlockFilledLight;